export enum TutorTaskModal {
  Create = 'create',
  Edit = 'edit',
  Postpone = 'postpone',
  PostponeDeclined = 'postpone-declined',
  Cancel = 'cancel',
  Delete = 'delete',
}
